var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendIconActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6757 0.881652C22.9436 1.14114 23.0941 1.47658 23.1257 1.82135C23.1341 1.91204 23.1343 2.00376 23.1259 2.09537C23.1144 2.22184 23.087 2.34718 23.0434 2.46814L16.3117 22.5177C16.1135 23.108 15.5712 23.5145 14.949 23.5391C14.3268 23.5637 13.7541 23.2014 13.5099 22.6286L9.88322 14.1224L1.73761 10.3485C1.1867 10.0933 0.843997 9.53109 0.869495 8.92447C0.894994 8.31784 1.28367 7.78642 1.85405 7.57832L21.0871 0.561144C21.2004 0.517029 21.3182 0.487177 21.4375 0.471646C21.5289 0.459677 21.6208 0.456252 21.7119 0.461124C22.0531 0.479158 22.3898 0.61322 22.6579 0.864641C22.6639 0.870256 22.6698 0.875926 22.6757 0.881652ZM16.0777 5.58225L6.29243 9.15241L10.6958 11.1925L16.0777 5.58225ZM12.8054 13.327L18.0785 7.83013L14.7229 17.8244L12.8054 13.327Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIconActive);
export default __webpack_public_path__ + "static/media/send-icon-active.55922e3beefae939b0c0019391aa0ff1.svg";
export { ForwardRef as ReactComponent };